import React from 'react';
import { RecoilRoot } from 'recoil';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { CookiesProvider, withCookies } from 'react-cookie';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import portalDefault from './themes/portal-default';
import './styles/main.scss';
import withAppPreLoad from './hocs/withAppPreload';
import { compose } from 'ramda';

import Navigator from './modules/Navigator/Navigator.container';
import { StylesProvider } from '@material-ui/core';
import withIdleTimeout from './modules/IdleTimeout/WithIdleTimeout';

const MainApp = compose(
  withCookies,
  withIdleTimeout,
  withAppPreLoad
)(() => (
  <BrowserRouter basename="/patient-portal">
    <Navigator />
  </BrowserRouter>
));

const App = () => (
  <StylesProvider injectFirst={true}>
    <MuiThemeProvider theme={portalDefault}>
      <ThemeProvider theme={portalDefault}>
        <RecoilRoot>
          <CookiesProvider>
            <MainApp />
          </CookiesProvider>
        </RecoilRoot>
      </ThemeProvider>
    </MuiThemeProvider>
  </StylesProvider>
);

export default App;
